import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.readTogetherLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCollectionData = createSelector(
  (state) => state.readTogetherLevels.data.readTogetherCollectionData,
  (collection = {}) => collection
);
const getCurrencyData = createSelector(
  (state) => state.readTogetherLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.readTogetherLevels.data.readTogetherLevels,
  (levels = []) => levels
);

export default {
  getCollectionData,
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
